import commonMapping from "@/mapping/common";

const email_schedule_type_list = [
  { value: "full", config: "log_full", label: "email_full" },
  { value: "Hourly", label: "email_hourly", config: "hourly" },
  { value: "Daily", label: "email_daily", config: "daily" },
  { value: "Weekly", label: "email_weekly", config: "weekly" },
  { value: "None", label: "email_none", config: "none" },
];
const email_schedule_day_list = [
  { value: "0", label: "schedule_sun", config: "Sunday" },
  { value: "1", label: "schedule_mon", config: "Monday" },
  { value: "2", label: "schedule_tue", config: "Tuesday" },
  { value: "3", label: "schedule_wed", config: "Wednesday" },
  { value: "4", label: "schedule_thu", config: "Thursday" },
  { value: "5", label: "schedule_fri", config: "Friday" },
  { value: "6", label: "schedule_sat", config: "Saturday" },
];
const email_schedule_time_24_list = [];
for (let i = 0; i < 24; i++) {
  const item = { value: i.toString(), config: i.toString(), label: "" };
  let label = "";
  label = i.toString();
  label += ":00";
  item.label = label;
  email_schedule_time_24_list.push(item);
}
const email_schedule_time_12_list = [];
for (let i = 0; i < 12; i++) {
  const item = { value: i.toString(), config: i.toString(), label: "" };
  let label = "";
  label = i.toString();
  label += ":00";
  item.label = label;
  email_schedule_time_12_list.push(item);
}
const email_schedule_ampm_list = [
  { value: "am", label: "am_mark", config: "am", id: "alert_am" },
  { value: "pm", label: "pm_mark", config: "pm", id: "alert_pm" },
];

export const email = {
  email_enable: commonMapping.intToBoolean,
  smtp_auth_enable: commonMapping.intToBoolean,
  send_alert_enable: commonMapping.intToBoolean,
  email_schedule_type: email_schedule_type_list,
  email_schedule_day: email_schedule_day_list,
  email_schedule_time_24: email_schedule_time_24_list,
  email_schedule_time_12: email_schedule_time_12_list,
  email_schedule_ampm: email_schedule_ampm_list,
};

export default email;
